import { render, staticRenderFns } from "./FixedLayout.vue?vue&type=template&id=30bb5cbe&"
import script from "./FixedLayout.vue?vue&type=script&lang=js&"
export * from "./FixedLayout.vue?vue&type=script&lang=js&"
import style0 from "./FixedLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports